"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var EmbedWidgetMenu_1 = __importDefault(require("./EmbedWidgetMenu"));
var ResizerComponent_1 = __importDefault(require("../ResizerComponent/ResizerComponent"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var WidgetTokenDropArea_1 = require("../WidgetTokenDropArea/WidgetTokenDropArea");
var VariableActions_1 = require("Project/QwilrEditor/Behaviours/VariableActions");
var styles = __importStar(require("./EmbedWidget.css"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var EmbedWidget = (function (_super) {
    __extends(EmbedWidget, _super);
    function EmbedWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.showError = false;
        _this.dropAreaWidthInPixels = 0;
        _this.frameRef = react_1.default.createRef();
        _this.handleResize = function (width, height) {
            var updateData = {
                action: "update",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: _this.props.embedType === "iframe" ? { width: width, height: height } : { width: width },
            };
            _this.props.triggerWidgetEvent(updateData);
            _this.fireResizeTelemetry();
        };
        _this.handleAlignmentChange = function (alignment) {
            var updateData = {
                action: "update",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: { alignment: alignment },
            };
            _this.props.triggerWidgetEvent(updateData);
        };
        _this.deleteWidget = function () {
            var updateData = {
                action: "delete",
                path: _this.props.widgetManager.getPath(_this.props.element),
            };
            _this.props.triggerWidgetEvent(updateData);
        };
        _this.handleUrlChange = function (displayUrl) { return __awaiter(_this, void 0, Promise, function () {
            var e_1;
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.showError = false;
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4, ((_b = (_a = this.props).handleDisplayUrlChange) === null || _b === void 0 ? void 0 : _b.call(_a, displayUrl))];
                    case 2:
                        _c.sent();
                        return [3, 4];
                    case 3:
                        e_1 = _c.sent();
                        (0, mobx_1.runInAction)(function () {
                            _this.showError = true;
                        });
                        return [3, 4];
                    case 4: return [2];
                }
            });
        }); };
        _this.removeToken = function () {
            _this.props.triggerWidgetEvent({
                action: "update",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: {
                    variable: null,
                },
            });
        };
        _this.updateToken = function (token) {
            _this.props.triggerWidgetEvent({
                action: "update",
                path: _this.props.widgetManager.getPath(_this.props.element),
                toUpdate: {
                    variable: token,
                    displayUrl: "",
                    embedUrl: "",
                },
            });
        };
        _this.maybeTokenOptions = function () {
            var _a;
            if (_this.props.allowVariables) {
                return {
                    tokenUtilities: {
                        removeToken: _this.removeToken,
                        confirmToken: _this.updateToken,
                        token: (_a = _this.props.variableDetails) === null || _a === void 0 ? void 0 : _a.variable,
                    },
                };
            }
            else {
                return {};
            }
        };
        _this.getEmbeddedComponent = function () {
            if (_this.props.embedUrl) {
                return (react_1.default.createElement("div", { className: "embed-widget__iframe-container" },
                    react_1.default.createElement("iframe", { src: _this.props.embedUrl, className: "embed-widget__iframe" }),
                    _this.props.showPlaceholderAsOverlay && (react_1.default.createElement(kaleidoscope_1.Stack, { justify: "center", align: "center", className: styles.overlay },
                        react_1.default.createElement("div", { className: styles.overlayInner }, _this.props.placeholder)))));
            }
            else if (_this.props.allowVariables && !_this.props.showPlaceholderInsteadOfTokenDropArea) {
                return _this.renderDropArea();
            }
            else {
                return _this.props.placeholder;
            }
        };
        _this.renderDropArea = function () {
            var _a;
            var _b = _this.props, isSelected = _b.isSelected, variableDetails = _b.variableDetails;
            if (!variableDetails) {
                return null;
            }
            return (react_1.default.createElement(WidgetTokenDropArea_1.WidgetTokenDropArea, { isSelected: isSelected, onDrop: _this.onTokenDrop, variableName: (_a = variableDetails.variable) === null || _a === void 0 ? void 0 : _a.label, icon: variableDetails.icon, instructions: variableDetails.instructions, size: _this.props.embedType === "iframe" ? WidgetTokenDropArea_1.WidgetTokenDropAreaSize.Auto : WidgetTokenDropArea_1.WidgetTokenDropAreaSize.Large }));
        };
        _this.updateDropAreaWidthInPixels = function () {
            if (_this.dropAreaElem) {
                var dropAreaRect = _this.dropAreaElem.getBoundingClientRect();
                if (dropAreaRect.width !== _this.dropAreaWidthInPixels) {
                    _this.dropAreaWidthInPixels = dropAreaRect.width;
                }
            }
        };
        _this.onTokenDrop = function (event) {
            var variable = (0, VariableActions_1.getVariableTokenFromDragEvent)(event);
            if (!variable) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            _this.props.triggerWidgetEvent({
                action: "dropVariable",
                path: _this.props.widgetManager.getPath(_this.props.element),
                variable: variable,
            });
        };
        return _this;
    }
    EmbedWidget.prototype.componentDidUpdate = function (prevProps) {
        this.updateDropAreaWidthInPixels();
    };
    EmbedWidget.prototype.render = function () {
        var _a;
        var _b = this.props, hasExtendedSelector = _b.hasExtendedSelector, minWidthPx = _b.minWidthPx, minHeightPx = _b.minHeightPx, width = _b.width, height = _b.height, displayUrl = _b.displayUrl, placeholderText = _b.placeholderText, errorMsg = _b.errorMsg, widgetManager = _b.widgetManager, attributes = _b.attributes, children = _b.children, isSelected = _b.isSelected, embedType = _b.embedType, alignment = _b.alignment;
        var aspectRatio = undefined;
        if (["map", "video"].includes(embedType)) {
            aspectRatio = 9 / 16;
        }
        return (react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)({
                "embed-widget": true,
                "embed-widget--not-focused": !this.embedWidgetIsSelected,
                "embed-widget--selected": this.embedWidgetIsSelected,
                "embed-widget--view-only": !widgetManager.canEdit,
            }) }, attributes),
            react_1.default.createElement(ResizerComponent_1.default, { aspectRatio: aspectRatio, alignment: alignment !== null && alignment !== void 0 ? alignment : "center", handleResize: this.handleResize, handleAlignmentChange: this.handleAlignmentChange, hasExtendedSelector: hasExtendedSelector, isSelected: isSelected, minWidthPx: minWidthPx, minHeightPx: minHeightPx, width: width || 100, height: height || 100, resizableHeight: embedType === "iframe" },
                hasExtendedSelector && (react_1.default.createElement("div", { className: (0, classnames_1.default)({
                        "embed-widget__extended-selector": true,
                        "embed-widget__extended-selector--selected": this.embedWidgetIsSelected,
                    }), contentEditable: false })),
                react_1.default.createElement("div", { ref: this.frameRef, className: (0, classnames_1.default)((_a = {
                            "embed-widget__frame": true,
                            center: true,
                            "embed-widget__frame--extended": hasExtendedSelector
                        },
                        _a[styles.widgetBackground] = true,
                        _a)) }, this.getEmbeddedComponent())),
            this.props.menu ? (this.props.menu(this.frameRef)) : (react_1.default.createElement(EmbedWidgetMenu_1.default, __assign({ key: displayUrl, placeholderText: placeholderText, handleDisplayUrlChange: this.handleUrlChange, displayUrl: displayUrl || "", handleDelete: this.deleteWidget, showMenu: this.embedWidgetIsSelected, errorMsg: errorMsg, showError: this.showError }, this.maybeTokenOptions()))),
            children));
    };
    EmbedWidget.prototype.fireResizeTelemetry = function () {
        var embedType = null;
        switch (this.props.embedType) {
            case "video":
                embedType = EditorTypes_1.BlockType.Video;
                break;
            case "map":
                embedType = EditorTypes_1.BlockType.GoogleMaps;
                break;
            case "iframe":
                embedType = EditorTypes_1.BlockType.Iframe;
                break;
        }
        this.props.telemetry.inlineContentResized(embedType);
    };
    Object.defineProperty(EmbedWidget.prototype, "embedWidgetIsSelected", {
        get: function () {
            return this.props.isSelected;
        },
        enumerable: false,
        configurable: true
    });
    var _a;
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], EmbedWidget.prototype, "showError", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof HTMLElement !== "undefined" && HTMLElement) === "function" ? _a : Object)
    ], EmbedWidget.prototype, "dropAreaElem", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], EmbedWidget.prototype, "dropAreaWidthInPixels", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], EmbedWidget.prototype, "frameRef", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EmbedWidget.prototype, "handleUrlChange", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], EmbedWidget.prototype, "updateDropAreaWidthInPixels", void 0);
    EmbedWidget = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], EmbedWidget);
    return EmbedWidget;
}(react_1.default.Component));
exports.default = EmbedWidget;
